import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../../environments/environment';

import { Observable, catchError, forkJoin, switchMap, throwError } from "rxjs";
import { slotsData } from '../../modules/slotsmodel/slotsdata';
import { maplayModule } from "../../modules/slotsmodel/slotsdata";
@Injectable({
  providedIn: "root",
})
export class SlotsService {
  private _livecasinoJson = 'assets/liveCasino.json';
  private _crashGames = 'assets/crash_game.json';
  private IndieCasino = "assets/indiecasino.json";
  private Paymentjson = "assets/PaymentBanking.json";
  private providerList_json = "assets/providersList.json";
  private arrorsEdgejs = "assets/arrowedge.json";
  private platipusgmjs = "assets/platipus.json";
  private NewHabanero = "assets/HabaneroGames-1.json";
  private kagamesjsn = "assets/Kagames.json";
  private netEntgames = "assets/netEnt.json";
  private indianGames = "assets/indianGames.json";
  private AMBGamesList = "assets/AMBgamesList.json";
  private GTFgamesList = "assets/GTFgamesList.json";
  private HRGgamesList = "assets/HRGgamesList.json";
  private injoyGamesList = "assets/injoyGamesList.json";
  private JDBgamesList = "assets/JDBGamesList.json";
  private spribeGamesList = "assets/spribeGamesList.json";
  private YBgamesList = "assets/YBgamesList.json";
  private rocketmanGames = "assets/rocketmangames.json";
  private redtigerGames = "assets/redtiger.json";
  private historyData = "assets/gameHistory.json"
  private cashoutJson = "assets/currencies.json"
  affiliate_data!: string;
  private homeBanners = "assets/homeBanners.json";
  private TorroProvider = "assets/torrospinProvider.json";
  private pragmaticPlayAllGamesJson = "assets/pragmaticPlayAllGames.json";
  private lotteryjson = "assets/lotto.json";
  private peaches18GameJson = "assets/18peaches.json";

  constructor(private http: HttpClient) { }
  homebanners() {
    return this.http.get(`/capi/home-banners?locale=en&fields[0]=routerLink&fields[1]=ImageStatus&fields[2]=locale&populate[heroBanner][fields][0]=url`);
  }
  gameList() {
    return this.http.get(`/capi/games-lists?filters[gameProviderName][$eq]=gameList&fields[0]=gamesList&fields[1]=gameProviderName&populate[tags][fields][0]=tags`);
  }
  httpOptions() {
    let option = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        siteid: environment.skinId,
        wsession: sessionStorage.getItem("wsessionBD") || '',
      }),
    }
    return option
  }
  private httpOption = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      siteid: environment.skinId,
    }),
  };
  liveCasinoGames(): Observable<any> {
    return this.http.get(this._livecasinoJson);
  }

  lotteryProvider(): Observable<any> {
    return this.http.get(this.lotteryjson);
  }
  getPeaches18GameJson(): Observable<any> {
    return this.http.get(this.peaches18GameJson);
  }
  getCrash() {
    return this.http.get<any>(this._crashGames);
  }
  TorroProviderAll() {
    return this.http.get<any>(this.TorroProvider);
  }
  public getlottery(): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.lotteryUrl
      }${sessionStorage.getItem("profile")}`,
      this.httpOption
    );
  }
  public getEzugi(data: string | null): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.ezugi
      }/${data}`,
      this.httpOption
    );
  }
  public getevo(data: string | null): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.ezugi
      }/${data}`,
      this.httpOption
    );
  }
  public getone_Button(): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.Live_dealer
      }${sessionStorage.getItem("profile")}`,
      this.httpOption
    );
  }
  public playerDeposit(depositData: { paymentMethod: any; paymentType: string; currency: string; country?: string; depositType?: string; amount: any; email?: any; phone?: any; city?: any; street?: any; postal_code?: any; Type?: string; payMethod?: string; wsession?: string | null; phoneNumber?: string; type?: string; userName?: string | null; address?: any; emailId?: string; emailid?: string; key?: string; upi_no?: any; }): Observable<any> {
    return this.http.post(
      `${environment.api.baseUrl}${environment.api.cashier.deposit}`, depositData, this.httpOptions());
  }
  getActivePromoCodes() {
    return this.http.post(`${environment.api.baseUrl}${environment.api.cashier.ActivePromoCodes}`, this.httpOptions());
  }

  indiecasino(data: string | null): Observable<any> {
    return this.http.get(`${environment.api.baseUrl}${environment.api.indiecasino}/${data}`, this.httpOptions());
  }
  public playerDepositCallback(body: { sid: any; amount: any; status: string; txid: any; }): Observable<any> {
    return this.http.post(
      `${environment.api.baseUrl}${environment.api.cashier.DepositCallBack}`,
      body,
      this.httpOptions()
    );
  }
  public depostpostback(body: { sid: any; }): Observable<any> {
    return this.http.post(
      `${environment.api.baseUrl}${environment.api.cashier.depositepostbackurl}`,
      body,
      this.httpOptions()
    );
  }
  getGameHistoryData() {
    return this.http.get(this.historyData)
  }
  public PaymentOptions(): Observable<any> {
    return this.http.get(this.Paymentjson);
  }
  public IndieCasinoJson(): Observable<any> {
    return this.http.get(this.IndieCasino);
  }
  public getproviderList(): Observable<any> {
    return this.http.get(this.providerList_json);
  }
  public arrorsEdgegm(): Observable<any> {
    return this.http.get(this.arrorsEdgejs);
  }

  public platipusgm(): Observable<any> {
    return this.http.get(this.platipusgmjs);
  }
  public rocketgm(): Observable<any> {
    return this.http.get(this.rocketmanGames);
  }
  getCurrencies(): Observable<any> {
    return this.http.get(this.cashoutJson);

  }
  public NewHabenaroJSON(): Observable<any> {
    return this.http.get(this.NewHabanero);
  }
  public kagm(): Observable<any> {
    return this.http.get(this.kagamesjsn);
  }
  public redtigerGamesjs(): Observable<any> {
    return this.http.get(this.redtigerGames);
  }
  public netEntGM(): Observable<any> {
    return this.http.get(this.netEntgames);
  }
  public getIndianGames(): Observable<any> {
    return this.http.get(this.indianGames);
  }
  public AMBgames(): Observable<any> {
    return this.http.get(this.AMBGamesList);
  }
  public GTFgames(): Observable<any> {
    return this.http.get(this.GTFgamesList);
  }
  public HRGgames(): Observable<any> {
    return this.http.get(this.HRGgamesList);
  }
  public injoyGames(): Observable<any> {
    return this.http.get(this.injoyGamesList);
  }
  public getPragmaticPlayAllGames(): Observable<any> {
    return this.http.get(this.pragmaticPlayAllGamesJson);
  }
  public JDBgames(): Observable<any> {
    return this.http.get(this.JDBgamesList).pipe(
      catchError(error => {
        return throwError(error);
      })
    );
  }
  public spribeGames(): Observable<any> {
    return this.http.get(this.spribeGamesList);
  }
  public YBgames(): Observable<any> {
    return this.http.get(this.YBgamesList);
  }
  BannersHome() {
    return this.http.get(this.homeBanners);
    // return this.http.get(`${"https://zupwinbd.com/"}${'bannershome.json'}`);
  }

  ProvidersJson(): Observable<any> {
    return this.http.get(`${"https://zupwinbd.com/"}${'providersList.json'}`);
  }
  btisportsjsfile(): Observable<any> {
    return this.http.get(`${"https://zupwinbd.com/assets/js/btisports.js"}`);
  }
  liveDealerServiceData(data: string | null): Observable<any> {
    return this.http.get(`${environment.api.baseUrl}${environment.api.ezugi}/${data}`)
  }
  getSlottyUrl(data: { gameId: any; gameMode: string; provider: any; }) {
    return this.http.post<slotsData>(`${environment.api.baseUrl}${environment.api.allGamesUrl}`, data, this.httpOptions());
  }
  paymentMethi(data: string | null) {
    let wsession = sessionStorage.getItem("wsessionBD");
    return this.http.post(`${environment.api.baseUrl}${environment.api.paymentMethi}/${data}`, wsession, this.httpOptions());
  }
  mplayGamesLaunch(postdata: { gameId: string; brand: string; launchToken: any; }) {
    return this.http.post<maplayModule>(`${environment.api.baseUrl}${environment.api.player.mPlayUrl}`, postdata, this.httpOptions());
  }
  gamelunch(data: any) {
    return this.http.get(`${environment.api.baseUrl}${environment.api.gameurl}/${data}`,);
  }
  onCashierGetOpenWithdrawRequest() {
    return this.http.post(`${environment.api.baseUrl}${environment.api.cashier.getOpenWithdrawRequests}`, {}, this.httpOptions());
  }
  onCashierCancelWithdrawRequest(postData: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.cashier.cancelWithdrawRequest}`, postData, this.httpOptions());
  }
  vivogame() {
    return this.http.get(`${environment.api.baseUrl}${environment.api.vivourl}`, this.httpOptions());
  }
  getpermissionList(postData: { role: number; }) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.getpermissionData}`, postData, this.httpOptions());
  }
  getprovidersbeforelogin() {
    return this.http.post(`${environment.api.baseUrl}${environment.api.getprovidersbeforelogin}`, this.httpOptions());
  }
  setFavoutite(body: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.setFavoutite}`, body, this.httpOptions());
  }
  getFavoutite(body: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.getFavoutite}`, body, this.httpOptions());
  }
  removeFavoutite(body: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.deleteFavouriteGame}`, body, this.httpOptions());
  }
  generateOTP(data: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.generateOTP}`, data, this.httpOptions());
  }
  jdbLaunch(gtype: any, mtype: any) {
    let body = {
      // "gameId" : "bbbb"
    }
    let httpWsessionpragmatic = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        wsession: sessionStorage.getItem("wsessionBD") || '',
        "mType": mtype,
        "gType": gtype,
      }),
    };
    return this.http.post(`${environment.api.baseUrl}${environment.api.jdbLaunch}`, body, httpWsessionpragmatic);
  }
  sportgm() {
    return this.http.get(`${environment.api.baseUrl}${environment.api.sportoken}`, this.httpOptions());
  }
  SportsBook(data: any) {
    return this.http.get(`${environment.api.baseUrl}${environment.api.sportsbook}/${data}`, this.httpOptions());
  }
  isDesktop(): boolean {
    const userAgent = navigator.userAgent;
    return !/Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
  }
  public redirectUrl(data: { redirectUrl: any; amount?: any; seque_no: any; label?: any; currency_code?: any; payMethod?: string; }) {
    let wsession = sessionStorage.getItem("wsessionBD");
    const url = `${data.redirectUrl}?seque_no=${data.seque_no}&wsession=${wsession}`
    if (this.isDesktop()) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  }
  httpClient(data: any, gameID: any): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.heblounch}/${data}/${gameID}`,
      this.httpOptions()
    );
  }
  httpClientendr(data: string | null, body: any): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.endrophi}/${data}/${body}`,
      this.httpOptions()
    );
  }
  getPragmaticHit(data: any) {
    let body = {
      // "gameId": data
    }
    return this.http.post(`${environment.api.baseUrl}${environment.api.pragmatictoken}/${data}`, body, this.httpWsession11());
  }
  aviatrix(body: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.aviatrix}`, body, this.httpWsession11());
  }
  getmancalagm(data: any) {
    let body = {
    }
    return this.http.post(`${environment.api.baseUrl}${environment.api.mancalagameurl}/${data}`, body, this.httpWsession11());
  }
  newezugievolution(data: any) {
    let body = {
      "provider": data.provider,
      "lang": "en"
    }
    return this.http.post(`${environment.api.baseUrl}${environment.api.newEzugievo}/${data.id}`, body, this.httpWsession11());
  }
  closeGameSession(body: any) {
    return this.http.post<any>(`${environment.api.baseUrl}${environment.api.player.closeGameSession}`, body, this.httpWsession11())
  }
  getTorrospinGameLaunch(postData) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.player.getTorrospinGameLaunch}`, postData, this.httpWsession11());
  }
  kingmidaslaunch(postData) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.player.kingmidas}`, postData, this.httpWsessionlang());
  }
  gvproviderapi(data: any) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.gvprovider}`, data, this.httpOptions());
  }
  gameclose() {
    return this.http.post<any>(
      `${environment.api.baseUrl}${environment.api.player.gameClose}`,
      {},   // <-- body
      this.httpOptions1()  // <-- options (with headers)
    );
  }
  gamelunallvivogaming() {
    return this.http.get(`${environment.api.baseUrl}${environment.api.vivoslots}`, this.httpWsession11());
  }
  gamelunallproviders(data) {
    return this.http.get(`${environment.api.baseUrl}${environment.api.vivoslots1}/${data.provider}/${data.gameId}/` + 'en', this.httpWsession11());
  }
  getCurrencyInfo(symbol: string) {

    return this.http.get(`${environment.api.baseUrl}${environment.api.cashier.crypto}/${symbol}`);
  }

  endsession() {
    return this.http.post(`${environment.api.baseUrl}${environment.api.player.endsession}`, {}, this.httpOptions());
  }

  getCoinPaymentConverstionRate() {
    return this.http.get(`${environment.api.baseUrl}${environment.api.getCoinPaymentConverstionRate}`, this.httpWsessionehtn());
  }

  onGetPlayerGameHistory(data: Object) {
    return this.http.post(`${environment.api.baseUrl}${environment.api.player.playerGameHistory}`, data, this.httpWsession11());
  }
  rubygame(data: any) {
    let body = {
      // "gameId" : "bbbb"
    }
    let httpWsessionpragmatic = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        wsession: sessionStorage.getItem("wsessionBD") || '',
        "gameId": data
      }),
    };
    return this.http.post(`${environment.api.baseUrl}${environment.api.bubyplayurl}`, body, httpWsessionpragmatic);
  }

  vibralaunch(data: any) {
    let body = {
      // "gameId" : "bbbb"
    }
    let httpWsessionpragmatic = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        wsession: sessionStorage.getItem("wsessionBD") || '',
        "gameId": data
      }),
    };
    return this.http.post(`${environment.api.baseUrl}${environment.api.vibraurl}`, body, httpWsessionpragmatic);
  }


  httpClientfun(): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.hebfunlounch}`,
      this.httpOption
    );
  }
  public jtDemourl(ProName: string | null): Observable<any> {
    return this.http.get(
      `${environment.api.baseUrl}${environment.api.JT
      }${ProName}`,
      this.httpOptions()
    );

  }
  transactionDetail(body: { seque_no: any; txnId: any; }): Observable<any> {
    return this.http.post<any>(`https://luckycoin.undertesting.com/api/cashier/trazPayDepositStatus`, body)
  }

  launchFreshDeck() {
    return this.http.get<any>(`${environment.api.sports.freshdeck}`, this.httpOptions());

  }

  httpWsession11() {
    let opotion = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        wsession: sessionStorage.getItem("wsessionBD") || '',
        siteid: environment.skinId,

      }),
    }
    return opotion;
  };
  httpWsessionlang() {
    let opotion = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        wsession: sessionStorage.getItem("wsessionBD") || '',
        siteid: environment.skinId,
        lang: 'en-US'
      }),
    }
    return opotion;
  };
  httpOptions1() {
    let option = {

      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "token": localStorage.getItem("tokenTorro") || ""
      })
    }
    return option
  };
  httpWsessionehtn() {
    let opotion = {

      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",

      }),
    }
    return opotion;
  };
}
